(function () {
    'use strict';

    run.admin.parts.rackootCreate = function () {
        const csrf_name = document.getElementsByName('csrf_name')[0].value;
        const csrf_value = document.getElementsByName('csrf_value')[0].value;

        const slideDown = element => element.style.height = `${element.scrollHeight}px`;

        let manualValidator;
        let aiValidator;

        // Welcome - Create first rackoot template
        const welcomeTemplate = document.getElementById('create_rackoot_welcome_dialog_template');
        if (welcomeTemplate != null && welcomeTemplate != 'undefined') {
            Swal.fire({
                title: null,
                html: welcomeTemplate.innerHTML,
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                focusCancel: true,
                cancelButtonText: translations.confirmAlerts.close,
                buttonsStyling: false,
                width: '40%',
                customClass: {
                    cancelButton: 'btn btn-lg btn-light',
                },
                showClass: {
                    popup: 'animate__animated animated__fast animate__fadeInUp'
                },
                hideClass: {
                    popup: 'animate__animated animated__fast animate__fadeOutDown'
                },
                didOpen: () => {
                    document.getElementById('new_rackoot_subject').focus();
                    addCreateRackootListeners();
                    addCreateRackootValidators();
                    addViewExamplesListener();
                }
            })
        }

        // Create rackoot template
        let html = document.getElementById('create_rackoot_dialog_template').innerHTML;

        // const create_rackoot_container = document.getElementById('rackoots_items__create');
        const create_rackoot_button = document.getElementById('rackoots_items__create');
        if (create_rackoot_button != null) {
            create_rackoot_button.addEventListener('click', async function (e) {
                // const countItems = document.getElementById('rackoots_dropdown_list').querySelectorAll('li').length;
                //const countItems = document.querySelectorAll('.swiper-slide.rackoot__item').length;
                const maxRackoots = create_rackoot_button.dataset.maxRackoots;
                const countItems = create_rackoot_button.dataset.countRackoots;
                if (countItems >= maxRackoots) {
                    Swal.fire({
                        title: translations.rackoots.create.title,
                        html: translations.rackoots.create.errors.maxReached,
                        showCloseButton: false,
                        showCancelButton: true,
                        showConfirmButton: false,
                        focusCancel: true,
                        cancelButtonText: translations.confirmAlerts.close,
                        confirmButtonText: translations.confirmAlerts.createRackoot,
                        buttonsStyling: false,
                        //reverseButtons: true,
                        customClass: {
                            cancelButton: 'btn btn-lg btn-light',
                            confirmButton: 'btn btn-lg btn-primary ms-4'
                        },
                        showClass: {
                            popup: 'animate__animated animated__fast animate__fadeInUp'
                        },
                        hideClass: {
                            popup: 'animate__animated animated__fast animate__fadeOutDown'
                        }
                    }).then((result) => {
                        if (result.value) {}
                    });
                } else {
                    Swal.fire({
                        title: translations.rackoots.create.title,
                        html: html,
                        showCloseButton: true,
                        showCancelButton: false,
                        showConfirmButton: false,
                        focusCancel: true,
                        cancelButtonText: translations.confirmAlerts.close,
                        buttonsStyling: false,
                        width: '40%',
                        customClass: {
                            cancelButton: 'btn btn-lg btn-light',
                        },
                        showClass: {
                            popup: 'animate__animated animated__fast animate__fadeInUp'
                        },
                        hideClass: {
                            popup: 'animate__animated animated__fast animate__fadeOutDown'
                        },
                        didOpen: () => {
                            document.getElementById('new_rackoot_name').focus();
                            addCreateRackootListeners();
                            addCreateRackootValidators();
                            addViewExamplesListener();
                        }
                    })
                }
            });
        }

        function addViewExamplesListener() {
            document.getElementById("btn_view_examples").addEventListener("click", function (e) {
                e.target.setAttribute('disabled', 'disabled');
                slideDown(document.getElementById("slide_animation_wrapper"));
            });
        }

        function addCreateRackootListeners() {
            const btnManual = document.getElementById('btn_create_rackoot_manual');
            const btnAi = document.getElementById('btn_create_rackoot_ai');
            const btnsCopyPrompt = document.querySelectorAll('.btn-copy-prompt');

            if (btnManual !== null) {
                btnManual.addEventListener('click', createManually);
            }

            if (btnAi !== null) {
                btnAi.addEventListener('click', createAi);
            }

            for (let i = 0; i < btnsCopyPrompt.length; i++) {
                btnsCopyPrompt[i].addEventListener('click', function (e) {
                    const prompt = e.target.parentNode.querySelector('.new_rackoot_prompt');
                    const target = document.getElementById(e.target.dataset.target);

                    target.value = prompt.innerText;
                    aiValidator.revalidate().then(isValid => {
                    });
                });
            }
        }

        function addCreateRackootValidators() {
            const formManual = document.getElementById('form_create_rackoot_manual');
            const formAi = document.getElementById('form_create_rackoot_ai');

            if (formManual !== null && formManual !== 'undefined') {
                manualValidator = new JustValidate('#form_create_rackoot_manual');
                manualValidator
                    .addField('#new_rackoot_name', [{
                            rule: 'required',
                        },
                        {
                            rule: 'minLength',
                            value: 3,
                        },
                        {
                            rule: 'maxLength',
                            value: 100,
                        },
                    ])
            }    

            if (formAi !== null && formAi !== 'undefined') {
                aiValidator = new JustValidate('#form_create_rackoot_ai');
                aiValidator
                    .addField('#new_rackoot_subject', [{
                            rule: 'required',
                        },
                        {
                            rule: 'minLength',
                            value: 20,
                        },
                        {
                            rule: 'maxLength',
                            value: 200,
                        },
                    ])
                }

            return;
        }

        function createManually() {
            if (!manualValidator.isValid) {
                return;
            }

            const subjectel = document.getElementById('new_rackoot_name');
            const buttonEl = document.getElementById('btn_create_rackoot_manual');
            const rackoot_name = subjectel.value;

            const prevLabel = buttonEl.innerText;
            subjectel.setAttribute('disabled', 'disabled');
            buttonEl.setAttribute('disabled', 'disabled');
            buttonEl.innerText = 'Creating rackoot...';
            // Save
            var data = new FormData();
            data.append('csrf_name', csrf_name);
            data.append('csrf_value', csrf_value);
            data.append('name', rackoot_name);

            axios.post(GlobalRoutes.rackoots.create, data)
                .then(function (response) {
                    window.location = response.data.data.url;
                })
                .catch(function (error) {
                    new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                    subjectel.removeAttribute('disabled');
                    buttonEl.removeAttribute('disabled');
                    buttonEl.innerText = prevLabel;
                });
        }

        function createAi() {
            if (!aiValidator.isValid) {
                return;
            }

            const subjectel = document.getElementById('new_rackoot_subject');
            const buttonEl = document.getElementById('btn_create_rackoot_ai');
            const subject = subjectel.value;
            const examplesEl = document.getElementById('create_rackoot_ai_examples_wrapper');
            
            //examplesEl.classList.add('animate__animated', 'animate__fadeOut');

            const prevLabel = buttonEl.innerText;
            subjectel.setAttribute('disabled', 'disabled');
            buttonEl.setAttribute('disabled', 'disabled');
            buttonEl.innerText = 'Creating rackoot...';

            // Save
            var data = new FormData();
            data.append('csrf_name', csrf_name);
            data.append('csrf_value', csrf_value);
            data.append('subject', encodeURI(subject));

            axios.post(GlobalRoutes.rackoots.createAi, data)
                .then(function (response) {
                    window.location = response.data.data.url;
                })
                .catch(function (error) {
                    new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                    subjectel.removeAttribute('disabled');
                    buttonEl.removeAttribute('disabled');
                    buttonEl.innerText = prevLabel;
                });
        }
    }
})();